import LabeledInputField from '#src/client/common/interactive/LabeledInputField.jsx';

function LabeledInput(props) {
    return (
        <LabeledInputField {...props} inputType="input" />
    );
}

export default LabeledInput;
